import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareAccessRoute: InvariantJiraRoute = {
	name: 'project-settings-software-access',
	path: '/jira/software/projects/:projectKey/settings/access',
	exact: true,
};
